module.exports = __webpack_public_path__ + "img/Capture3.1a8a7de2.jpg";